"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    id: "loginRegisterModalHeadlineId",
    tabindex: "-1",
    class: "z-11 absolute left-0 top-0 m-0 h-[5.14285714rem] w-full border-b-2 border-gray-40 bg-white p-4 text-[2rem] font-semibold leading-[2.714285714rem] lg:static lg:border-b-0 lg:pt-8 lg:text-center"
};
const _hoisted_2 = { class: "mx-auto block max-w-[400px] lg:max-w-[unset]" };
const store_1 = require("@/state/store");
const detectingMobile_1 = __importDefault(require("@/services/detectingMobile"));
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'HeadlineModalMobil',
    setup(__props) {
        const { isMobile } = (0, detectingMobile_1.default)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(isMobile) && !(0, vue_2.unref)(store_1.store).isLandingPage)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h2", _hoisted_1, [
                    (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? "login.headline" : "registration.headline")), 1)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
